module.exports = __webpack_public_path__ + "static/media/main-user-info-back-team.c7473cd3.png";